(function () {
  function patchScrollCarousel() {
    if (!window.customElements.get('scroll-carousel')) return false;

    const proto = window.customElements.get('scroll-carousel').prototype;
    if (proto.__pageStepPatched) return true;
    proto.__pageStepPatched = true;

    const originalSelect = proto.select;

    proto.select = function (index, options = {}) {
      const previousIndex = this.selectedIndex;

      // Arrow clicks only + collection list only
      if (
        Math.abs(index - previousIndex) === 1 &&
        this.querySelector('.collection-list')
      ) {
        const step = this.slidesPerPage || 1;
        const direction = index > previousIndex ? 1 : -1;

        index = previousIndex + direction * step;
        index = Math.max(0, Math.min(index, this.items.length - 1));
      }

      return originalSelect.call(this, index, options);
    };

    return true;
  }

  if (!patchScrollCarousel()) {
    customElements.whenDefined('scroll-carousel').then(patchScrollCarousel);
  }
})();